module.exports = __webpack_public_path__ + "static/media/delete-icon-red.0e41860d.svg";